'use client';

// BL-1600 — the shell's 3-line adapter over `@auctogon/admin-frontend`'s
// SessionProvider (sharing.md § 1's wrapper contract).
//
// It exists because the layouts that render SessionProvider are SERVER
// components and cannot pass a function prop across the boundary, and because
// `authClient` cannot move into the package: it types
// `customSessionClient<StaffAuth>()`, and `StaffAuth` is inferred from the
// server-side Better Auth instance. `apps/bidder-web` keeps its own client for
// the same reason. See `@auctogon/admin-frontend/api-client/auth-ops`.

import type { ReactNode } from 'react';
import { SessionProvider } from '@auctogon/admin-frontend/components/session/SessionProvider';
import { OfflineSessionShell } from '@auctogon/admin-frontend/components/offline/OfflineSessionShell';
import type { SessionBootstrapPayload } from '@auctogon/core-admin/schemas/responses/session';
import { authClient } from '@/lib/auth/client';

/** Renders the package's SessionProvider with this app's Better Auth client bound in. */
export function AppSessionProvider({
    sessionPromise,
    children,
}: {
    sessionPromise: Promise<SessionBootstrapPayload>;
    children: ReactNode;
}) {
    return (
        <SessionProvider sessionPromise={sessionPromise} authOps={authClient}>
            {children}
        </SessionProvider>
    );
}

/**
 * The offline route group's twin (BL-2343): the package's OfflineSessionShell with this app's
 * Better Auth client bound in, for the same reason as {@link AppSessionProvider}.
 */
export function AppOfflineSessionShell({ children }: { children: ReactNode }) {
    return <OfflineSessionShell authOps={authClient}>{children}</OfflineSessionShell>;
}
